module.exports = __webpack_public_path__ + "static/media/no-notification.8939acfe.svg";